import { Directive, HostListener, HostBinding, Output, EventEmitter } from '@angular/core';

/**
 * Directive that adds to the element a drop file actions 
 */
@Directive({
  selector: '[fileDragNDrop]'
})
export class FileDragNDropDirective {
  /** Event that send the files that the user has dropped in the html element */
  @Output() private filesChangeEmiter : EventEmitter<File[]> = new EventEmitter();

  private originalBorderStyl = '1px solid';
  private originalBorderColorStyl = 'gray';
  private originalBkgColorStyl = '#eee';

  @HostBinding('style.background') background = this.originalBkgColorStyl;
  @HostBinding('style.border') borderStyle = this.originalBorderStyl;
  @HostBinding('style.border-color') borderColor = this.originalBorderColorStyl;
  @HostBinding('style.border-radius') borderRadius = '5px';

  @HostListener('dragover', ['$event']) public onDragOver(evt: any){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'lightgray';
    this.borderColor = 'cadetblue';
    this.borderStyle = '1px dashed';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = this.originalBkgColorStyl;
    this.borderColor = this.originalBorderColorStyl;
    this.borderStyle = this.originalBorderStyl;
  }

  @HostListener('drop', ['$event']) public onDrop(evt: any){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = this.originalBkgColorStyl;
    this.borderColor = '#696D7D';
    this.borderStyle = this.originalBorderStyl;
    let files = evt.dataTransfer.files;
    let valid_files : Array<File> = files;
    this.filesChangeEmiter.emit(valid_files);
  }
}